export const getRoutePresence = (name: string) => {
  if (!name) return true

  const router = useRouter()
  const getRouteBaseName = useRouteBaseName()

  const routeNames = router.getRoutes()?.map((route) => {
    return getRouteBaseName(route)
  })

  return routeNames?.includes(name)
}
